<template>
  <div>
    <header-bar>レポート</header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">速報レポート</h3>
        <router-link
          :to="{ name : 'faq-detail', params: {id: isBtoC ? 59 : 80} }"
          target="_blank"
          class="c-text-link">
          速報レポートについて
        </router-link>
      </div>
      <div class="page-block__inner">
        <div class="report-area">
          <div class="report-area__text">
            月末に確定する配信ストアの実際の販売数に関しては
            <br class="sp">
            <router-link
              :to="{ name : 'report-finalized' }"
              class="c-text-link">
              確定レポート
            </router-link>をご確認ください。
          </div>
        </div>
        <form>
          <div
            class="form-wrap form-wrap--report"
            style="margin-bottom: 0; flex-wrap: wrap;">
            <div style="display: flex;flex-direction: column; margin: 12px">
              <div class="form-group--report">
                <div class="form-label form-label--report">
                  <label
                    class="control-label"
                    style="width: 150px"
                    for="artist">
                    アーティスト</label>
                </div>
                <div class="form-item">
                  <div class="form-item-inline form-item-inline-report">
                    <span class="form-item__wrap">
                      <artist-selector
                        v-model="artistId" />
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="form-group--report"
                style="margin-top: 12px">
                <div class="form-label form-label--report">
                  <label
                    class="control-label"
                    style="width: 150px"
                    for="artist">
                    タイトル
                  </label>
                </div>
                <div class="form-item">
                  <div class="form-item-inline form-item-inline-report">
                    <span class="form-item__wrap">
                      <product-selector
                        v-model="productId"
                        :artist-id="artistId" />
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="form-group--report"
                style="margin-top: 12px">
                <div class="form-label form-label--report">
                  <label
                    class="control-label"
                    style="width: 150px"
                    for="artist">
                    楽曲
                  </label>
                </div>
                <div class="form-item">
                  <div class="form-item-inline form-item-inline-report">
                    <span class="form-item__wrap">
                      <track-selector
                        v-model="trackId"
                        :product-id="productId" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-group form-group--report"
              style=" margin: 12px">
              <div class="form-label form-label--report">
                <label
                  class="control-label"
                  for="type">表示期間</label>
              </div>
              <div
                class="form-item"
                style="display: flex">
                <div class="form-item-inline form-item-inline--sp-reset form-item-inline-report">
                  <span class="form-item__wrap">
                    <date-range-selector
                      @input="onChangeMode"
                      @change-range="onChangeRange"
                      @dateChanged="reportedDate=$event" />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </form>
        <p class="caution-text">
          ※速報レポートはあくまで速報値ですので、
          <router-link
            :to="{ name : 'report-finalized' }"
            class="c-text-link">
            確定レポート
          </router-link>
          の販売数とは異なる場合がございます。<br>
        </p>
        <div class="report-block streaming">
          <div class="report-block__heading">
            <h3 class="report-block__title c-with-icon">
              <svg
                class="icon-streaming svg-icon"
                viewBox="0 0 17 23.5">
                <path
                  class="color1"
                  d="M11.4,21.9c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7c4.8-5.3,4.8-13.9,
                  0-19.1c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0c5.2,5.6,5.2,14.8,0,
                  20.5C11.7,21.9,11.6,21.9,11.4,21.9z M9.2,18.9c3.7-4.1,3.7-10.7,0-14.8C9,3.9,
                  8.7,3.9,8.5,4.1c-0.2,0.2-0.2,0.5,0,0.7c3.4,3.7,3.4,9.7,0,13.5c-0.2,0.2-0.2,
                  0.5,0,0.7c0.1,0.1,0.2,0.1,0.3,0.1C9,19.1,9.1,19,9.2,18.9z M6.6,16c2.3-2.5,
                  2.3-6.6,0-9.1c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7c2,2.1,2,5.6,0,
                  7.8c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.1,0.3,0.1C6.3,16.2,6.5,16.2,6.6,
                  16z M0,11.5c0,1.1,0.9,2,2,2s2-0.9,2-2s-0.9-2-2-2S0,10.4,0,11.5z" />
              </svg>ストリーミング
            </h3>
            <div class="report-block__heading-date report-date">{{ streamingLatestDate }}</div>
          </div>
          <ranking-table
            :artist-id="artistId"
            :is-subscription="1"
            :summary-type="summaryType"
            :provider-ids="providerIds"
            :is-provider-summary="true"
            :ranges="ranges"
            :product-id="productId"
            :track-id="trackId"
            @latestDate="streamingLatestDate=$event">
          </ranking-table>
        </div>
        <div class="report-block download">
          <div class="report-block__heading">
            <h3 class="report-block__title c-with-icon">
              <svg
                class="icon-song svg-icon"
                viewBox="0 0 17.044 23.033">
                <path
                  class="color1"
                  d="M17.026,21.46a1.362,1.362,0,0,1-.012.509,1.34,1.34,0,0,1-1.535,
                  1.038H1.581a1.338,1.338,0,0,1-.259.026,1.352,1.352,0,0,1-.328-.041,
                  1.325,1.325,0,0,1-.968-1.54V1.507a1.057,1.057,0,0,1,0-.274A1.387,
                  1.387,0,0,1,.553.3,1.377,1.377,0,0,1,1.585.011l11.148,0,.146.146c4.047,
                  4.04,4.047,4.04,4.091,4.125a.5.5,0,0,1-.815.564C16,4.68,13.84,2.526,
                  12.319,1.007H1.526a.455.455,0,0,0-.354.079.4.4,0,0,0-.15.267l0,.154L1.01,
                  21.631a.322.322,0,0,0,.392.392l.124-.016,14.105.011a.337.337,0,0,0,
                  .406-.261.349.349,0,0,0,0-.144l-.011-.105-.014-14.5H12.526a2.917,2.917,0,
                  0,1-2.494-2.421l-.006-3.079a.5.5,0,1,1,1,0v3a1.9,1.9,0,0,0,1.579,
                  1.507l4.407-.007Zm-14.5-3.3a2.2,2.2,0,0,1,1.866-1.919,1.907,1.907,0,0,1,
                  1.176.088V9.97a.415.415,0,0,1,.289-.391l6.087-2.072a.457.457,0,0,1,
                  .4.051.409.409,0,0,1,.184.339v7.464h-.015c0,.035.012.069.012.1a2.2,2.2,0,
                  0,1-1.866,1.919,2.394,2.394,0,0,1-.469.049h0A1.754,1.754,0,0,1,
                  9.114,17.1a1.256,1.256,0,0,1-.5-1.013,2.2,2.2,0,0,1,1.866-1.919,1.9,1.9,
                  0,0,1,1.179.091v-3.7L6.442,12.334v5.1H6.427c0,.036.012.07.012.106a2.2,2.2,
                  0,0,1-1.866,1.919,2.394,2.394,0,0,1-.469.049,1.755,1.755,0,0,
                  1-1.077-.338A1.254,1.254,0,0,1,2.527,18.157Zm9.129-2.691a.45.45,0,0,
                  0-.178-.368.88.88,0,0,0-.531-.151h0a1.53,1.53,0,0,0-1.464,1.137.443.443,0,
                  0,0,.178.368,1.032,1.032,0,0,0,.818.123A1.389,1.389,0,0,0,11.656,
                  15.466Zm-5.214-5.2v1.19l5.217-1.777V8.486ZM3.4,18.157a.441.441,0,0,0,
                  .178.367,1.028,1.028,0,0,0,.818.123,1.386,1.386,0,0,0,1.177-1.108.446.446,
                  0,0,0-.178-.367.874.874,0,0,0-.531-.152h0a1.378,1.378,0,0,0-.287.03A1.385,
                  1.385,0,0,0,3.4,18.157Z" />
              </svg>ダウンロード
            </h3>
            <div class="report-block__heading-date report-date">{{ downloadLatestDate }}</div>
          </div>
          <ranking-table
            :artist-id="artistId"
            :is-subscription="0"
            :summary-type="summaryType"
            :provider-ids="providerIds"
            :ranges="ranges"
            :product-id="productId"
            :track-id="trackId"
            @latestDate="downloadLatestDate=$event">
          </ranking-table>
        </div>
      </div>
    </div>
    <confirm-dialog
      name="realtimeReportStore"
      :is-shown="showStoreDialog"
      title="ストア詳細"
      cancel-button-title="閉じる"
      default-button-title="再集計"
      @closed="showStoreDialog = false"
      @cancel-clicked="showStoreDialog = false"
      @default-clicked="onReloadClicked">
      <template #body>
        <div class="consent-checkbox-area">
          <div class="checkbox realtime-store-detail-max-width">
            <label v-if="selectStoreModeStreaming">
              <input
                v-model="selectProviderIds"
                :value="1"
                type="checkbox">
              <div class="option-input"></div>
              <span class="u-text-align-left">
                Spotify (ストリーミング)
              </span>
            </label>
            <label v-if="selectStoreModeStreaming">
              <input
                v-model="selectProviderIds"
                :value="2"
                type="checkbox">
              <div class="option-input"></div>
              <span class="u-text-align-left">
                Apple Music (ストリーミング)
              </span>
            </label>
            <label v-if="selectStoreModeStreaming">
              <input
                v-model="selectProviderIds"
                :value="4"
                type="checkbox">
              <div class="option-input"></div>
              <span class="u-text-align-left">
                AWA (ストリーミング)
              </span>
            </label>
            <label v-if="!selectStoreModeStreaming">
              <input
                v-model="selectProviderIds"
                :value="20"
                type="checkbox">
              <div class="option-input"></div>
              <span class="u-text-align-left">
                iTunes Store
              </span>
            </label>
            <label v-if="!selectStoreModeStreaming">
              <input
                v-model="selectProviderIds"
                :value="21"
                type="checkbox">
              <div class="option-input"></div>
              <span class="u-text-align-left">
                レコチョク (レコチョク / Music Store powered by レコチョク / dミュージック / ひかりTVミュージック)
              </span>
            </label>
            <div class="realtime-report-detail-text">
              ※速報レポートが提供されているストアは上記のみとなります。<br>上記ストア以外は確定レポートでのご確認となります。
            </div>
          </div>
        </div>
      </template>
    </confirm-dialog>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'
import RankingTable from './RankingTable'
import ConfirmDialog from '../../../components/ConfirmDialog'
import DateRangeSelector from './DateRangeSelector'
import ArtistSelector from './ArtistSelector'
import TrackSelector from './TrackSelector'
import ProductSelector from './ProductSelector'

export default {
  components: {
    ProductSelector,
    TrackSelector,
    ArtistSelector,
    DateRangeSelector,
    ConfirmDialog,
    RankingTable,
    HeaderBar,
  },
  data() {
    return {
      reportedDate: null,
      summaryType: 'daily',
      artistId: '',
      showStoreDialog: false,
      selectProviderIds: [],
      providerIds: [1, 2, 4, 20, 21],
      selectStoreModeStreaming: false,
      downloadLatestDate: '',
      streamingLatestDate: '',
      ranges: [],
      productId: null,
      trackId: null,
    }
  },
  watch: {
    productId: {
      handler() {
        this.trackId = null
      },
      immediate: false,
    },
    artistId: {
      handler() {
        this.productId = null
        this.trackId = null
      },
      immediate: false,
    },
  },
  mounted() {
  },
  methods: {
    openStoreDetailClicked(selectStoreModeStreaming) {
      this.selectStoreModeStreaming = selectStoreModeStreaming
      this.showStoreDialog = true
      this.$set(this, 'selectProviderIds', [...this.providerIds])
    },
    onReloadClicked() {
      this.showStoreDialog = false
      this.$set(this, 'providerIds', [...this.selectProviderIds])
    },
    onChangeRange(value) {
      this.ranges = value
    },
    onChangeMode(value) {
      this.summaryType = value
    },
  },
}

</script>

<style scoped>
.c-select {
  max-width: 500px;
}
.realtime-store-detail-max-width {
  margin-right: 0!important;
}
</style>
